<template>
  <div class="share-history-item flex">
    <div class="flex-1">
      <div>
        <span class="share-account-name" v-if="item.name">{{ item.name }}</span>
      </div>
      <div class="mt-1" v-if="item.answerTime">
        <span class="share-answer-time">答题时间：{{ item.answerTime }}</span>
      </div>
      <!--      <div><span class="share-sorry-text mt-2">很遗憾，分享红包已被全部领取~</span></div>-->
    </div>
    <div class="share-history-status text-right">
      <div class="text-right">
        <span v-if="item.amount">+{{ item.amount }}</span>
      </div>
      <span class="text-green-theme" v-if="isSuccess">审核通过</span>
      <span class="text-danger" v-else-if="isRefuse">已驳回</span>
      <span class="text-theme" v-else-if="isSubmit">已提交</span>
      <span class="text-theme-black-250" v-else-if="isAnswering">未提交</span>
    </div>
  </div>
</template>

<script>
import { AnswerStatus } from 'dygc'

export default {
  name: 'ShareHistoryItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isSuccess() {
      return this.item.status === AnswerStatus.PASS
    },
    isRefuse() {
      return this.item.status === AnswerStatus.QUALITY
    },
    isSubmit() {
      return this.item.status === AnswerStatus.OK
    },
    isAnswering() {
      return this.item.status === 3
    }
  }
}
</script>
